import { httpTenantsService } from 'utils/http'
import { IAddUser, IUserPreference, IUserProfile, UserPreferencesKeysEnum } from './settingsTypes'

enum RelativeRootEnum {
  users = 'users',
  session = 'session',
  verify = 'verify',
  resetPassword = 'reset-password',
}

enum PreferencesRelativeRootEnum {
  preferencesDefaults = 'preferences/defaults',
  preferencesUsers = 'preferences/users',
  preferenceTenantUsers = 'preferences/tenantUsers',
  preferencesRoles = 'preferences/roles',
  preferencesTenants = 'preferences/tenants',
  preferencesTenantRoles = 'preferences/tenantRoles',
  preferencesHighest = 'preferences/highest',
  preferencesCustomer = 'preferences/customers',
}

export const settingsServiceApiPaths = {
  user: (id: string) => `${RelativeRootEnum.users}/${id}`,
  users: RelativeRootEnum.users,
  tenantPreferencesPut: () => `${PreferencesRelativeRootEnum.preferencesTenants}`,
  tenantPreferencesGet: (key: string) => `${PreferencesRelativeRootEnum.preferencesTenants}/${key}`,
  customerPreferencesPut: () => `${PreferencesRelativeRootEnum.preferencesCustomer}`,
  customerPreferencesGet: (key: string) => `${PreferencesRelativeRootEnum.preferencesCustomer}/${key}`,
  // tenantUserPreferencesGet: (key?: string) => `${PreferencesRelativeRootEnum.preferenceTenantUsers}/${key}`,

  tenantUserPreferencesGet: (key?: string) =>
    key
      ? `${PreferencesRelativeRootEnum.preferencesHighest}/${key}`
      : PreferencesRelativeRootEnum.preferenceTenantUsers,

  tenantUserPreferencesPut: (key?: string) =>
    key
      ? `${PreferencesRelativeRootEnum.preferenceTenantUsers}/${key}`
      : PreferencesRelativeRootEnum.preferenceTenantUsers,

  userPreferencesGet: (key?: string) =>
    key ? `${PreferencesRelativeRootEnum.preferencesHighest}/${key}` : PreferencesRelativeRootEnum.preferencesUsers,

  // userPreferencesGet: (key?: string) => `${PreferencesRelativeRootEnum.preferencesUsers}/${key}`,

  userPreferencesPut: (key?: string) =>
    key ? `${PreferencesRelativeRootEnum.preferencesUsers}/${key}` : PreferencesRelativeRootEnum.preferencesUsers,

  session: RelativeRootEnum.session,
  verifyUser: (username: string) => `${RelativeRootEnum.users}/${RelativeRootEnum.verify}/${username}`,
  resetUserPassword: (username: string) => `${RelativeRootEnum.users}/${RelativeRootEnum.resetPassword}/${username}`,
}

export const getUserProfile = async (url: string) => {
  const { data } = await httpTenantsService.get(url)
  return data as IUserProfile
}

export const verifyUserProfile = async (url: string) => {
  const { data } = await httpTenantsService.get(url)
  return data
}

export const resetUserPassword = async (url: string) => {
  const { data } = await httpTenantsService.post(url)
  return data
}

export const getSession = async () => {
  const { data } = await httpTenantsService.get(settingsServiceApiPaths.session)
  return data.user as IUserProfile
}

export const getUsers = async (url: string) => {
  const { data } = await httpTenantsService.get(url)
  return data as IUserProfile[]
}

export const getUserPreference = async (url: string): Promise<Record<string, never> | IUserPreference | any> => {
  const currentTenant = sessionStorage.getItem(UserPreferencesKeysEnum.outboundAiPreferredTenant)
  const tenantUrl = settingsServiceApiPaths.userPreferencesGet(UserPreferencesKeysEnum.outboundAiPreferredTenant)
  if (!currentTenant) {
    const { data } = await httpTenantsService.get(tenantUrl)

    if (data?.value) {
      sessionStorage.setItem(UserPreferencesKeysEnum.outboundAiPreferredTenant, data?.value)
    }
  }

  const { data, status } = await httpTenantsService.get(url)
  // When a key does not exist the backend returns 204 and an empty string which causes the UI to stay in a loading state because there is no data and no error
  return status === 204 ? {} : data
}

export const setUserPreference = async (url: string, payload: IUserPreference) => {
  const { data } = await httpTenantsService.put(url, payload)
  return data as IUserPreference
}

export const addUser = async (body: IAddUser) => {
  const { data } = await httpTenantsService.put(RelativeRootEnum.users, body)
  return data as IUserProfile
}
